import React from 'react';
import { styled } from '@mui/system';
import { AppBar, Toolbar, Typography, IconButton, MenuItem, Menu } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../reducers/auth_reducer';
import { useNavigate } from 'react-router-dom';

import { RootState } from '../store/store';
import LanguageSwitcher from '../Components/Others/LanguagesSwitcher';

const drawerWidth = 280;

const StyledAppBar = styled(AppBar)(({ theme }) => ({
  width: `calc(100% - ${drawerWidth}px)`,
  marginLeft: drawerWidth,
  backgroundColor: 'white',
  color: '#191919',
  boxShadow: 'none',
  borderBottom: '1px solid #E5E5E5',
}));

const StyledTypography = styled(Typography)({
  flexGrow: 1,
});

const UserNameText = styled(Typography)(({ theme }) => ({
  marginRight: theme.spacing(2),
}));

const Header: React.FC = () => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state: RootState) => state.authReducer.user);

  const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    dispatch(logout());
    navigate('/');
    handleClose();
  };

  return (
    <StyledAppBar position='fixed'>
      <Toolbar>
        <StyledTypography variant='h6'>
          eTicketing{' '}
        </StyledTypography>
        <LanguageSwitcher />
        <UserNameText>{user?.full_name}</UserNameText>
        <IconButton edge='start' color='inherit' aria-label='menu' onClick={handleMenu}>
          <MenuIcon />
        </IconButton>
        <Menu
          id='menu-appbar'
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
        >
          <MenuItem onClick={handleClose}>Profile</MenuItem>
          <MenuItem onClick={handleClose}>My account</MenuItem>
          <MenuItem onClick={handleLogout}>Logout</MenuItem>
        </Menu>
      </Toolbar>
    </StyledAppBar>
  );
};

export default Header;